"use client";

import { createContext, use, type ReactNode } from "react";

import type { PublicAppConfig } from "./config-server";

const AppConfigContext = createContext<PublicAppConfig | null>(null);

interface AppConfigProviderProps {
	children: ReactNode;
	config: PublicAppConfig;
}

export function AppConfigProvider({
	children,
	config,
}: AppConfigProviderProps) {
	return <AppConfigContext value={config}>{children}</AppConfigContext>;
}

export function useAppConfig(): PublicAppConfig {
	const config = use(AppConfigContext);
	if (!config) {
		throw new Error("useAppConfig must be used within an AppConfigProvider");
	}
	return config;
}
